/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 오늘의 홍보학교 페이지 공고 맞춤 추천 탭 요소 컴포넌트
 * 버전 : 1.0
 * 파일명 : PromotionRecommand.tsx
 * 작성자 : 강동형 
 * 작성일 : 2025-07-03
 * 수정 : 2025-07-04, 강동형 : API 연결 및 코드 작성
 * ================================================================ */

import { useEffect, useState } from 'react'
import CarouselSchedule from './CarouselSchedule'
import { Icon_EmptyMap } from '../common/CommonIcons';
import styled from 'styled-components';
import { postTodaysRecommendSchool } from 'src/api/Main';
import TodaysPromotionList, { BottomSheetTypeExtand } from './TodaysPromotionList';
import { useMainPageDialogStore } from 'src/stores/DialogStore';
import { parseSchoolData } from 'src/utils/Etc';

const PageWrapper = styled.div`
    display : flex;
    flex-direction: column;
    flex: 1;
`

const EmptyWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    width: 100%;
    height: 100%;
    flex: 1;
    font-size: 14px;
    font-weight: 500;
    color: #747474;
`
const ListWrapper = styled.div`
    padding: 0px 20px;
`

const PromotionRecommand = () => {
    const [top3,setTop3] = useState<BottomSheetTypeExtand[]>([])
    const [currentId,setCurrentId] = useState(0)
    const setField = useMainPageDialogStore((state)=>state.setField)
    const fetchTop3 = async () => {
        try {
            const response = await postTodaysRecommendSchool(currentId);  
            setTop3(response.data); // 받아온 데이터를 상태에 저장
        } catch (error) {
            console.error('top3 불러오기 실패:', error);
        }
    };
    useEffect(()=>{
        if(currentId !== 0){
            fetchTop3()
        }
    },[currentId])

  const handleClick = (e:any)=>{
    setField('isOpen',true)
    setField('selected',{...e, isAi : true})
  }

    return (
        <PageWrapper>
            <CarouselSchedule setCurrentId={setCurrentId}/>
            {top3.length === 0 ? 
                <EmptyWrapper>
                    <Icon_EmptyMap/>
                    <span>최근 60일 이내 마감 예정인 모집공고가 없습니다.</span>
                </EmptyWrapper>
            :
            <ListWrapper>
                {top3.map((item,index)=>(
                    <div onClick={()=>handleClick(item)}>
                    <TodaysPromotionList results={parseSchoolData(item)} isLast={top3.length-1 === index}/>
                    </div>
                ))}
            </ListWrapper>
            }
        </PageWrapper>
    )
}

export default PromotionRecommand